import { render, staticRenderFns } from "./StLocationTeaser.vue?vue&type=template&id=79bd3150"
import script from "./StLocationTeaser.vue?vue&type=script&lang=ts"
export * from "./StLocationTeaser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports